import React from 'react';
import styled from 'styled-components';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HomeSection from '../components/sections/HomeSection';

const HomeContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;
`;

const Main = styled.main`
  flex: 1;
`;

const HomeContainerComponent: React.FC = () => {
  return (
    <HomeContainer>
      <Header />
      <Main>
        <HomeSection />
      </Main>
      <Footer />
    </HomeContainer>
  );
};

export default HomeContainerComponent;
